import { skyCMP } from '../../utils/sky-cmp';
import { insertAfter, unHideElement } from '../../utils/dom-utils';
import { onLmpTabChange } from '../../utils/aem-utils';

import vendorsConfig from './vendors';

const BANNER_NO_COOKIES = '.c-banner-no-cookies';

export const initEmbeds = () => {
  vendorsConfig.forEach(handleCmpChange);
  onLmpTabChange(() => {
    setTimeout(() => {
      vendorsConfig.forEach(handleLmpTabChange);
    }, 5000);
  });
};

function handleCmpChange(vendorConfig) {
  skyCMP.onChange(vendorConfig.id, (consent) => {
    initEmbedsContainers(vendorConfig, consent);
  });
}

function handleLmpTabChange(vendorConfig) {
  const consent = vendorConfig.name ? skyCMP.hasCustomVendorGrant(vendorConfig.name) : false;
  initEmbedsContainers(vendorConfig, consent);
}

function initEmbedsContainers(vendorConfig, consent) {
  const $embedContainers = document.querySelectorAll(vendorConfig.selector);
  $embedContainers.forEach(($container, index) => {
    if (!$container.children.length || $container.dataset.initialized) {
      return;
    }
    if (consent) {
      initEmbedFromTemplate($container, vendorConfig.callback);
      if (index === $embedContainers.length - 1) {
        $container.dataset.initialized = true;
      }
    } else {
      showBannerCookie($container);
    }
  });
}

function initEmbedFromTemplate($container, callback) {
  if (hasTemplate($container)) {
    const $template = $container.children[0];
    const $element = $template.content.children[0];
    insertAfter($template, $element);
    const $bannerCookie = $container.querySelector(BANNER_NO_COOKIES);
    if ($bannerCookie) {
      $bannerCookie.parentNode.removeChild($bannerCookie);
    }
    if (callback) {
      callback();
    }
  }
}

function showBannerCookie($container) {
  const $bannerCookie = $container.querySelector(BANNER_NO_COOKIES);
  if ($bannerCookie) {
    unHideElement($bannerCookie);
  }
}

function hasTemplate($container) {
  return $container.children.length > 0 && $container.children[0].tagName?.toLowerCase() === 'template';
}
